import { useCallback } from 'react';

import {
  sendEmailVerificationEvent,
} from '@kueski-analytics/events/email_verification';
import useMerchantPaymentQuery from 'Hooks/useMerchantPaymentQuery';
import { isEmbeddedAmazon } from 'Utils/mobile';
import { amplitudeProductTypeByPaymentTypeAndChannel } from 'Utils/mappers';
import { ProtectedApplication } from 'Hooks/useProtectedApplication';
import { AmplitudeProductType } from 'Models/Amplitude/ProductTypes';

interface UseTrackSendEmailVerification {
  application: ProtectedApplication;
  paymentData: Exclude<ReturnType<typeof useMerchantPaymentQuery>['data'], null | undefined>;
}

export const useTrackSendEmailVerification = () => {
  const isEmbeddedAmzApp = isEmbeddedAmazon();

  return useCallback(({
    application,
    paymentData,
  }: UseTrackSendEmailVerification) => {
    const eventData = {
      application_id: application.application_process_id,
      is_embedded_amz: isEmbeddedAmzApp,
      kueski_user_id: application.customer_id,
      merchant_id: paymentData.payment?.merchantId,
      merchant_name: paymentData.payment?.merchantName,
      page_name: 'verify_email',
      product_type: amplitudeProductTypeByPaymentTypeAndChannel(
        application.payment_type ?? '',
        application.channel ?? '',
        true,
      ) as AmplitudeProductType,
      purchase_amount: paymentData.payment?.amount,
      recurrent: application.recurrent,
    };
    sendEmailVerificationEvent(eventData);
  }, [isEmbeddedAmzApp]);
};
